<template>
  <div
    class="bg-background-neutral-secondary flex w-full items-center justify-between pb-4"
  >
    <div class="space-y-1">
      <p class="text-text-neutral-primary text-lg font-bold">
        {{ totalPrice }}
      </p>
      <p class="text-text-neutral-primary text-base">
        {{ t('ancillaries.seatMap.totalPrice') }}
      </p>
    </div>
    <FreeButton
      type="button"
      class="green-main-button w-1/2"
      @click="emit('onContinue')"
    >
      {{ t('general.proceed') }}
    </FreeButton>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { FreeButton } from 'freedom-shared';
  import { prettyPrice } from '@aviata/text-fns';
  import { useI18n } from 'vue-i18n';
  import type { PassengerKey } from '@aviata/booking-data';

  import { seatMapLib } from './lib';
  import type { SelectedSeatsState } from './types';

  const props = defineProps<{
    seatMapState: SelectedSeatsState;
    passengersKeys: PassengerKey[];
    qaId: string;
  }>();

  const emit = defineEmits<{
    onContinue: [];
  }>();

  const { t } = useI18n();
  const totalPrice = computed(() => {
    const seatsPrice = seatMapLib.getSeatMapPrice(
      props.seatMapState,
      props.passengersKeys,
    );
    return seatsPrice > 0
      ? `${prettyPrice(seatsPrice.toString())} ₸`
      : t('general.price.free');
  });
</script>
